import { create } from "zustand";

export const UtilityStore = create((set) => ({
  // Displays the V2 Marketing Intelligence UI in its old location
  isMarketingFromTop: false,
  setIsMarketingIntelligence: (flag: boolean) => set({ isMarketingFromTop: flag }),

  getDisclosureName: (name: string) => {
    const docTypes: Record<string, string> = {
      Annual: "Annual Report",
      Proxy: "Proxy Statement",
      Sustainability: "Sustainability Report",
      URD: "Document d'Enregistrement Universel",
      BDC: "Brochure De Convocation",
    };

    return docTypes[name];
  },
}));
